import React from 'react';
import type { FunctionComponent } from 'react';
import { shortDateHandler, longDateHandler } from '@utils';

interface UsageExceededStatusProps {
	usageExceededOnUtc: string;
	becomeActiveOnUtc: string;
}

export const UsageExceededStatus: FunctionComponent<UsageExceededStatusProps> = ({
	usageExceededOnUtc,
	becomeActiveOnUtc,
}) => {
	return (
		<div className="account-status-tooltip">
			<p className="account-status-content-row account-status-content-row--bold">Usage Exceeded on:</p>
			<p className="account-status-content-row account-status-content-row--bottom-margin">
				{longDateHandler(usageExceededOnUtc)}
			</p>
			<p className="account-status-content-row account-status-content-row--bold">Become active on:</p>
			<p className="account-status-content-row">{shortDateHandler(becomeActiveOnUtc)}</p>
		</div>
	);
};
